import { setUser } from "../actions/user";
import { setWarehouseList } from "../actions/warehouse";
import { get } from "../utils/barrels/lodash";
import { reloadUser } from "../utils/functions";

import { axiosInstance } from "./apiInstance";
import urls from "./urls.json";
import { fetchAddressByPincode } from "./warehouseApi";

export const getWarehouseList =
	(pageNo, filterVals, query, fetchAll) => (dispatch) =>
		axiosInstance
			.get(urls.getWarehouseList, {
				params: {
					page: pageNo || undefined,
					all_records: fetchAll || undefined,
					q: query || undefined,
					...filterVals,
				},
			})
			.catch((err) => {
				if (err.response.status === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: false,
							showReAuthModal: false,
							requestType: "get",
						})
					);
					window.location.reload();
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 200) {
					dispatch(setWarehouseList(response.data));
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});

export const addWarehouseAsync = (obj) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.post(urls.createWarehouse, body)
			.catch((err) => {
				if (err.response.status === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const getStates = () => (dispatch) =>
	axiosInstance
		.get(urls.getStateList)
		.catch((err) => {
			if (err.response.status === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const editWarehouse = (obj, warehouseId) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.put(`/warehouses/${warehouseId}/`, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({ reAuth: true, showReAuthModal: true, requestType: "put" })
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const deleteWarehouse = (id) => (dispatch) =>
	axiosInstance
		.delete(`/warehouses/${id}`)
		.catch((err) => {
			if (err.response.status === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: true,
						showReAuthModal: true,
						requestType: "delete",
					})
				);
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 204) {
				return true;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const getMostUsedWarehouseList = (pageNo, filterVals) => (dispatch) =>
	axiosInstance
		.get(urls.getTopWarehouseList, {
			params: {
				page: pageNo || 1,
				...filterVals,
			},
		})
		.catch((err) => {
			if (err.response.status === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 200) {
				dispatch(setWarehouseList(response.data));
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

/**
 * Fetches address by pincode and updates warehouse list.
 * Handles 401 errors with user reload.
 *
 * @param {string} pincode - Pincode to fetch address for.
 * @returns {Function} Thunk action.
 */
export const getAddressByPincode = (pincode) => async (dispatch) => {
	try {
		const response = await fetchAddressByPincode({ pincode });

		if (response.status === 200) {
			dispatch(setWarehouseList(response.data));
			return response.data;
		} else {
			throw new Error(response.data.msg);
		}
	} catch (err) {
		if (err.response?.status === 401) {
			reloadUser();
			dispatch(
				setUser({
					reAuth: false,
					showReAuthModal: false,
					requestType: "get",
				})
			);
			window.location.reload();
		}
		throw err;
	}
};
